import { faEraser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useModalManager from "@hooks/useModalManager";
import { Button, ButtonProps } from "@ui";
import dynamic from "next/dynamic";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { AdditionalData, AutoFillReturn } from "../hooks";

const AutoFillDataPreview = dynamic(() => import("./AutoFillDataPreview"));

interface Props extends Pick<AutoFillReturn, "additionalData">, ButtonProps {
    prefix?: string;
}

const AutoFillSelector = ({ prefix = "form_data", additionalData, isLoading, ...props }: Props) => {
    const { setValue, reset } = useFormContext();
    const { addModal, removeModal } = useModalManager();

    const handleSelectData = useCallback(
        (data: AdditionalData) => {
            for (const [key, value] of Object.entries(data.data)) {
                setValue(`${prefix}.${key}`, value);
            }
        },
        [prefix]
    );

    const handleShowSelector = useCallback(() => {
        addModal({
            title: "Vorherige Daten auswählen",
            content: (id) => (
                <AutoFillDataPreview
                    onSelect={(data) => {
                        handleSelectData(data);
                        removeModal(id);
                    }}
                    additionalData={additionalData}
                />
            ),
        });
    }, [additionalData, addModal, removeModal, setValue, prefix]);

    if (!isLoading && additionalData?.length === 0) {
        return null;
    }

    return (
        <div className="tw-my-4 tw-flex tw-gap-2">
            <Button
                isLoading={isLoading}
                color="light"
                size="xs"
                block
                className="tw-flex-1"
                {...props}
                onPress={handleShowSelector}
            >
                Vorherige Daten auswählen ({additionalData?.length} Einträge gefunden)
            </Button>
            <Button color="warning" size="xs" className="tw-px-4" onPress={() => reset({ [prefix]: null })}>
                <FontAwesomeIcon icon={faEraser} />
            </Button>
        </div>
    );
};

export default AutoFillSelector;
